import React, { useEffect } from 'react'
import { PropTypes } from 'prop-types'
import SanityImage from 'gatsby-plugin-sanity-image'
import { Link } from 'gatsby'
import smoothscroll from 'smoothscroll-polyfill'
import Portal from '../portal'
import PortableText from '../portableText'
import {
	CloseModalButton,
	ModalTab,
	TopBar,
	VSMCTA,
	VSMModalBackdrop,
	VSMModalScroll,
	VSMModalScrollContent,
	VSMModalWrapper,
} from './VSMPhase.styles'

const ModalCopy = ({ portableTextBlock }) => <PortableText blocks={portableTextBlock} />

export default function VSMPhase({ phase, vsmPhaseCopy, vsmPhaseIcon, cta, forgetModal }) {
	// const isTablet = useMediaQuery('(max-width: 767px)')

	// kick off the polyfill for smooth-scroll (Safari doesn't support smooth-scroll as of 2021)!
	smoothscroll.polyfill()

	useEffect(() => {
		const escape = (e) => {
			if (e.key === 'Escape') forgetModal()
		}

		window.addEventListener('keydown', escape)
		return () => window.removeEventListener('keydown', escape)
	}, [])

	return (
		<Portal>
			<VSMModalBackdrop onClick={forgetModal} />
			<VSMModalWrapper className={`${phase}`}>
				<TopBar>
					<ModalTab>{phase}</ModalTab>
				</TopBar>
				<CloseModalButton type="button" onClick={forgetModal}>
					<div />
					<div />
				</CloseModalButton>
				<VSMModalScroll>
					<VSMModalScrollContent>
						<SanityImage {...vsmPhaseIcon} asset={vsmPhaseIcon.asset} alt={vsmPhaseIcon.alt} />
						<ModalCopy {...vsmPhaseCopy} />
					</VSMModalScrollContent>
					<VSMCTA>
						<Link
							to="#vsmDiscipline"
							onClick={() => {
								forgetModal()
								document.querySelector('#vsmDiscipline').scrollIntoView({ behavior: 'smooth' })
							}}
						>
							{cta}
						</Link>
					</VSMCTA>

					{/* {isTablet ? (
						<>
							{phase === 'ideate' && (
								<VSMCTA>
									<Link to="#vsmGridIdeate" onClick={forgetModal}>
										{cta}
									</Link>
								</VSMCTA>
							)}
							{phase === 'create' && (
								<VSMCTA>
									<Link to="#vsmGridCreate" onClick={forgetModal}>
										{cta}
									</Link>
								</VSMCTA>
							)}
							{phase === 'release' && (
								<VSMCTA>
									<Link to="#vsmGridRelease" onClick={forgetModal}>
										{cta}
									</Link>
								</VSMCTA>
							)}
							{phase === 'operate' && (
								<VSMCTA>
									<Link to="#vsmGridOperate" onClick={forgetModal}>
										{cta}
									</Link>
								</VSMCTA>
							)}
							{(phase === 'measure' || phase === 'optimize' || phase === 'customer') && (
								<VSMCTA>
									<Link to="#vsmDiscipline" onClick={forgetModal}>
										{cta}
									</Link>
								</VSMCTA>
							)}
						</>
					) : (
						<VSMCTA>
							<button type="button" onClick={forgetModal}>
								{cta}
							</button>
						</VSMCTA>
					)} */}
				</VSMModalScroll>
			</VSMModalWrapper>
		</Portal>
	)
}

VSMPhase.propTypes = {
	phase: PropTypes.string,
	vsmPhaseCopy: PropTypes.object,
	vsmPhaseIcon: PropTypes.object,
	cta: PropTypes.string,
	forgetModal: PropTypes.func,
}

ModalCopy.propTypes = {
	portableTextBlock: PropTypes.array,
}
